import type { AppProps } from 'next/app';

// Redux Configuration
import store from '../redux/store';
import { Provider } from 'react-redux';
import '../styles/globals.css';
import '../styles/_global.scss';
import '../styles/map.css';
import '../public/icons/style.css';

//  Global Css Files
import '@splidejs/react-splide/css';

// App Initialization
import RouterProvider from '@/components/app/providers/routerProvider/RouterProvider';
import DeviceProvider from '@/components/app/providers/deviceProvider/DeviceProvider';
import { UseragentDetails } from '@/components/app/types';

// React Toastify Configuration
import 'react-toastify/dist/ReactToastify.css';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import React from 'react';
import Scripts from '@/components/app/scripts/Scripts';
import { WhiteLabelProvider } from '@/components/app/providers/whiteLabelProvider/WhiteLabelProvider';
import { checkIsWhiteLabel } from '@/helpers/checkEnvironments';
export interface AppPropsType extends AppProps {
  ua: UseragentDetails;
}
const ToastContainer = dynamic(() => import('react-toastify').then(mod => mod.ToastContainer), {
  ssr: false
});
const RestComponents = dynamic(() => import('@/components/app/RestComponents'), {
  ssr: false
});
const App = ({
  Component,
  ...rest
}: AppPropsType) => {
  const isWhiteLabel = checkIsWhiteLabel();
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="_app.tsx">
        {isWhiteLabel && <meta name="robots" content="noindex, nofollow" />}
        <link rel="icon" type="image/x-icon" href={isWhiteLabel ? '/images/home/favicon-white.svg' : '/images/home/favicon.svg'} />
      </Head>
      <Provider store={store} data-sentry-element="Provider" data-sentry-source-file="_app.tsx">
        <DeviceProvider ua={rest.pageProps.ua} data-sentry-element="DeviceProvider" data-sentry-source-file="_app.tsx">
          <RouterProvider data-sentry-element="RouterProvider" data-sentry-source-file="_app.tsx">
            <WhiteLabelProvider data-sentry-element="WhiteLabelProvider" data-sentry-source-file="_app.tsx">
              <ToastContainer rtl={true} data-sentry-element="ToastContainer" data-sentry-source-file="_app.tsx" />
              <Component {...rest.pageProps} data-sentry-element="Component" data-sentry-source-file="_app.tsx" />
              <RestComponents data-sentry-element="RestComponents" data-sentry-source-file="_app.tsx" />
              <Scripts data-sentry-element="Scripts" data-sentry-source-file="_app.tsx" />
            </WhiteLabelProvider>
          </RouterProvider>
        </DeviceProvider>
      </Provider>
    </>;
};
export default App;